import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "HomeView",
    // component: HomeView,
    component: () => import("@/views/QuizView.vue"),
  },
  {
    path: "/quiz",
    name: "QuizView",
    component: () => import("@/views/QuizView.vue"),
  },
  {
    path: "/dashboard",
    name: "ResultDashBoard",
    component: () => import("@/views/ResultDashBoard.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
